class BESSAppProjectEditorRadioField extends BESSAppProjectEditorInputField {

    constructor(editor, item, field) {
        super(editor, item, field);
    }

    _templateForInput() {
        return '<div class="check-wrap app-validation-parent">\n' +
            '    <div class="form-check">\n' +
            '        <input class="form-check-input first" type="radio" value="1">\n' +
            '        <label class="form-check-label first">\n' +
            '            Yes\n' +
            '        </label>\n' +
            '    </div>\n' +
            '    <div class="form-check">\n' +
            '        <input class="form-check-input second" type="radio" value="0">\n' +
            '        <label class="form-check-label second">\n' +
            '            No\n' +
            '        </label>\n' +
            '    </div>\n' +
            '</div>'
    }

    initialise() {
        super.initialise();
        if (this._addChangeHandler()) {
            this.inputs.onChangeKeyUp(this, this._inputChanged);
        }

    }

    _configureView(node) {
        this.inputs = node.find('input');
        this.inputYes = node.find('input[value="1"]');
        this.inputNo = node.find('input[value="0"]');
        this.inputs.attr('name', this.editor.data.editorId + '_' + this.item.itemNo + '_' + this.field.label);
        this._setInputValue(this.getValue());
    }
    setValue(value) {
        this.storeLocalValue(value);
        this._setInputValue(value);
    }

    _setInputValue(value) {
        if(value !== null && value !== "") {
            this.inputYes.setCheckedIf(value);
            this.inputNo.setCheckedIf(!value);
        }
    }

    _getInputValue() {
        if(this.inputYes.isChecked()) {
            return true;
        }
        if(this.inputNo.isChecked()) {
            return false;
        }
        return null;
    }
}